var map = {
	"./tag-不可累计房晚和积分.svg": "5bdb",
	"./tag-专属价.svg": "e5c9",
	"./tag-会员专属价.svg": "6585",
	"./tag-免费取消.svg": "e7df",
	"./tag-入住前一天免费取消.svg": "a14d",
	"./tag-固定价.svg": "d49f",
	"./tag-累计积分.svg": "4a4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8e4";